<div class="section" [style.gap]="avatarTemplate ? '24px' : '16px'">
  <div *ngIf="avatarTemplate">
    <ng-container *ngTemplateOutlet="avatarTemplate"></ng-container>
  </div>
  @if (progressId() && progressMessage[progressId()]) {
    <div class="progress-text">
      @if (progressMessage[progressId()].icon) {
        <u-icon
          [model]="{ type: 'font', value: progressMessage[progressId()].icon }"
          [styles]="{ fontSize: '15px', lineHeight: '26px' }"
        ></u-icon>
      }
      <div>{{ progressMessage[progressId()].message }}</div>
    </div>
  } @else {
    <u-icon-blink
      [model]="{ type: 'font', value: 'icon-answer-star' }"
      [icon1FontSize]="customStyles?.icon1FontSize || '18px'"
      [icon2FontSize]="customStyles?.icon2FontSize || '10px'"
    ></u-icon-blink>
    <div *ngIf="showLoadingText" class="ghost-row">Looking for an answer...</div>
  }
</div>
